import React from "react";
import ChannelsAttention from "components/contact/ChannelsAttention";
import { NavLink } from "react-router-dom";
import ImageAccount from "assets/images/questions/Estado_de_mi_cuenta.png";
import "styles/footer.css";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <>
      <section className="centrar">
        <img
          src="/images/Banner_footer_GAC.jpg"
          alt="Grupo alianza colombia informa: No tenemos servicios tercerizados"
          className="img-fluid"
        />
      </section>
      <footer className="section-footer">
        <article className="section-footer-content">
          <div>
            <h5 className="title-article footer">
              Políticas, términos y condiciones
            </h5>
            <div className="container-item-footer">
              <a
                href="https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/uploads/SAGRILAFT.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                SAGRILAFT Y PTEE
              </a>
              <NavLink to="/terminos-y-condiciones">
                Términos y condiciones
              </NavLink>
              <a
                href="/files/TRATAMIENTO_DE_DATOS_PERSONALES-2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de tratamiento de datos personales
              </a>
              <a
                href="/files/Aviso_de_privacidad.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aviso de privacidad
              </a>
              <NavLink to="/politica-de-ley-de-retracto">
                Política ley de retracto
              </NavLink>
              <NavLink to="/politica-de-proteccion-de-menores">
                Política de protección a menores
              </NavLink>
              <a
                href="https://sedeelectronica.sic.gov.co/"
                target="_blank"
                rel="noopener noreferrer"
              >
                SuperIntendecia de Industria
              </a>
            </div>
          </div>
          <div>
            <h5 className="title-article footer">Servicio al cliente</h5>
            <div className="container-item-footer fading-vertical-border">
              <NavLink to="/pqrs">PQRS</NavLink>
              <NavLink to="/linea-etica">Línea ética</NavLink>
            </div>
          </div>
          <div className="fading-vertical-border">
            <h5 className="title-article footer">Medios de pago</h5>
            <section className="items-section-payments">
              <NavLink to="/pagos" className="btn-scale">
                <img
                  loading="lazy"
                  src={ImageAccount}
                  alt="mercado pago"
                  width={197}
                  height={58}
                />
              </NavLink>

              <NavLink to="/pagos">
                <img
                  loading="lazy"
                  src="/images/logo/logo-mercado-pago.svg"
                  alt="mercado pago"
                  width={180}
                  height={50}
                />
              </NavLink>
              <a
                href="https://portalpagos.davivienda.com/#/comercio/6857/GRUPO%20ALIANZA%20COLOMBIA%20SAS"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-davivienda"
              >
                PSE en{" "}
                <img
                  loading="lazy"
                  src="/images/logo/davivienda.webp"
                  alt="pse davivienda"
                  width={207}
                />
              </a>
              <button
                className="btn-bancolombia"
                data-bs-toggle="modal"
                data-bs-target="#Modal_QR_Bancolombia"
              >
                <img
                  loading="lazy"
                  src="/images/logo/bancolombia.svg"
                  width={200}
                  height={50}
                  alt="Pagar con Codigo QR de Bancolombia"
                />
              </button>
              <div
                className="modal fade"
                id="Modal_QR_Bancolombia"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog  modal-md">
                  <div className="modal-content">
                    <div className="modal-body">
                      <img
                        loading="lazy"
                        src="/files/QR.jpg"
                        alt=""
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="fading-vertical-border">
            <ChannelsAttention isFooter={true} />
          </div>
        </article>
        <article className="section-footer-bottom">
          <img
            loading="lazy"
            src="/images/logo/logo.webp"
            alt="logo"
            width={200}
          />
          <p>
            RNT N° 127027 Grupo Alianza Colombia SAS. NIT. 901088947-6, Oficina
            Principal Bogotá, Calle 93B # 17-25 Oficina 309-310-311 Edificio
            Centro Empresarial PH. Estamos comprometidos con: Ley 679 de 2001 y
            ley 1336 de 2009. Contra la explotación, la pornografía, el turismo
            sexual y otras formas de abuso a los menores. Decreto 2737 de 1989.
            Por el cual se expide el código del menor y en la cual está en
            contra de la explotación laboral infantil. Ley 397 de 1997. Contra
            el tráfico de Patrimonio Cultural. Ley 599 de 2000, decreto 1608 de
            1978 y Ley 1453 de 2011. Contra el tráfico de especies como flora y
            fauna silvestre. Ley 1335 de 2009. Antitabaco, por un espacio libre
            de humo del tabaco. Ley 1482 de 2011. Garantizar la protección de
            los derechos de una persona, grupo de personas, comunidad o pueblo,
            que son vulnerados a tráficos de actos de racismo o discriminación.
            Damos cumplimiento a lo establecido por la Ley 1581 de 2012, sobre
            protección de datos personales.
          </p>
        </article>
        <h6 className="center-text">
          <strong>
            © {year} | Todos los derechos reservados. Grupo Alianza Colombia.SAS
          </strong>
        </h6>
      </footer>
    </>
  );
};

export default Footer;
